import { render } from "./SpendingPlanPage.vue?vue&type=template&id=30b9e2bc&scoped=true"
import script from "./SpendingPlanPage.vue?vue&type=script&lang=js"
export * from "./SpendingPlanPage.vue?vue&type=script&lang=js"

import "./SpendingPlanPage.vue?vue&type=style&index=0&id=30b9e2bc&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-30b9e2bc"]])

export default __exports__